import React, { useEffect, useRef, useState } from "react";
import {
  FileMetaData,
  FilePreviewContainer,
  FileUploadContainer,
  FormField,
  ImagePreview,
  InputLabel,
  PreviewContainer,
  PreviewList,
  RemoveFileIcon,
  ShowContent,
  UploadFileBtn,
} from "./file-upload.styles";
import BaseService from "services/BaseService";
import pdf from "../../../assets/images/pdf.png";
import { getLang } from "helpers/common";
import { withTranslation } from "react-i18next";
import PropertyService from "services/Admin/PropertyService"
import { SuccessOk } from "configs/statusCode";

const DEFAULT_MAX_FILE_SIZE_IN_BYTES = 5000000;

const FileUpload = ({
  label,
  attachmentType,
  attachmentData,
  updatedAttachment,
  deleteAttachment,
  maxFileSizeInBytes = DEFAULT_MAX_FILE_SIZE_IN_BYTES,
  t,
  hasError,
  ...otherProps
}) => {
  const [percent, setPercent] = useState(0)
  const fileInputField = useRef(null);
  const [files, setFiles] = useState([]);
  const [lastAddedFiles, setLastAddedFiles] = useState([]);
  const acceptFileTypes = ["csv", "xls", "xlsx"];
  useEffect(() => {
    //if(attachmentData){
    setFiles(attachmentData);
    //}
  }, [attachmentData]);

  const handleUploadBtnClick = () => {
    fileInputField.current.click();
  };

  const addNewFiles = (newFiles) => {
    let files = [];
    for (let file of newFiles) {
      if (file.size <= maxFileSizeInBytes) {
        if (!otherProps.multiple) {
          return [file];
        }
        files.push(file);
      }
    }
    return files; // [...files]
  };

  const handleNewFileUpload = async (e) => {
    const { files: newFiles } = e.target;
    if (newFiles.length) {
      let updatedFiles = addNewFiles(newFiles);
      //TODO enhance if 50 file will send 50 ajax
      let createdFiles = [];
      const options = {
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          let percentValue = (loaded * 100) / total
          setPercent(percent => {
            const value = (percentValue - percent) / updatedFiles.length
            const updatedPercentage = value + percent
            if (percent > updatedPercentage) {
              return percent
            } else {
              return updatedPercentage
            }
          })
        }
      }
      Promise.all(
        updatedFiles.map(async (file) => {
          const fileType = file.name
            .split(".")[1]
            .split("")
            .map((character) => character.toLowerCase())
            .join("");

          const isFile =
            acceptFileTypes.findIndex((type) => type === fileType) > -1;
          let res;
          if (isFile) {
            new PropertyService().upload(file, options).then((res) => {
              if (res && res ?.status === SuccessOk){
                const createdFile = res ?.data ?.data;
                createdFiles.push(createdFile);
                if (!otherProps.multiple) {
                  setFiles(createdFiles);
                } else {
                  setFiles([...files, ...createdFiles]);
                }
                setLastAddedFiles(createdFiles);
              }else{
                setPercent(0)
              }
               
            })
          }

        }),
      ) 
    }
  };

  useEffect(() => {
    if (lastAddedFiles.length) {
      // updatedAttachment([...files], attachmentType)
      updatedAttachment(lastAddedFiles, attachmentType);
    }
  }, [lastAddedFiles]);

  const removeFile = (id) => {
    const updatedFiles = files.filter((f) => f.id !== id);
    setFiles([...updatedFiles]);
    // updatedAttachment([...updatedFiles], attachmentType)
    deleteAttachment(
      files.filter((f) => f.id === id),
      attachmentType,
    );
  };

  return (
    <>
      <FileUploadContainer
        style={{
          borderColor: `${
            hasError ? "rgb(220, 53, 69)" : "rgba(0, 0, 0 , 0.3)"
            } `,
          direction: getLang() === "ar" ? "rtl" : "ltr",
        }}>
        <InputLabel>{t(label)}</InputLabel>
        <UploadFileBtn type='button' onClick={handleUploadBtnClick}>
          <i className='fas fa-file-upload' />
          <span>{t(`Upload ${otherProps.multiple ? "files" : "a file"}`)}</span>
        </UploadFileBtn>
        <FormField
          type='file'
          ref={fileInputField}
          onChange={handleNewFileUpload}
          title=''
          value=''
          {...otherProps}
        />
      </FileUploadContainer>
      {percent > 0 &&
        <div className="progress">
          <div
            className="progress-bar progress-bar-striped"
            role="progressbar"
            style={{ width: percent + '%' }}
            aria-valuenow={`${percent}`}
            aria-valuemin="0"
            aria-valuemax="100"
          >
          </div>
        </div>
      }
      <FilePreviewContainer>
        <PreviewList>
          {files &&
            files.map((file, index) => {
              if (file ?.path) {
                return (
                  <PreviewContainer key={index}>
                    <div>
                      <ImagePreview
                        src={file.path}
                        alt={`file preview ${index}`}
                      />
                      <FileMetaData>
                        {/* <span>{file.name}</span> */}
                        <aside>
                          {/* <span>{convertBytesToKB(file.size)} kb</span> */}
                          <RemoveFileIcon
                            className='fas fa-trash-alt'
                            onClick={() => removeFile(file.id)}
                          />
                          <ShowContent
                            href={file.path}
                            target='_blank'
                            rel='noopener noreferrer'>
                            <RemoveFileIcon className='fas fa-eye' />
                          </ShowContent>
                        </aside>
                      </FileMetaData>
                    </div>
                  </PreviewContainer>
                );
              }
            })}
        </PreviewList>
      </FilePreviewContainer>
    </>
  );
};

export default withTranslation()(FileUpload);
